<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    required: true,
  },
  isComingSoon: {
    type: Boolean,
    default: false,
  },
});

const iconColor = computed(() => {
  const colorMap = {
    'i-woot-facebook': '#1877F2',
    'i-woot-messenger': '#1877F2',
    'i-woot-whatsapp': '#25D366',
    'i-woot-instagram': '#E4405F',
    'i-woot-telegram': '#0088CC',
    'i-woot-line': '#00B900',
    'i-woot-tiktok': '#000000',
    'i-ri-twitter-x-fill': '#000000',
    'i-ri-linkedin-box-fill': '#0A66C2',
    'i-ri-youtube-fill': '#FF0000',
    'i-ri-threads-fill': '#000000',
    'i-ri-google-fill': '#4285F4',
    'i-ri-phone-fill': '#8E44AD',
  };
  return colorMap[props.icon] || null;
});
</script>

<template>
  <button
    class="relative bg-n-solid-1 gap-6 cursor-pointer rounded-2xl flex flex-col justify-start transition-all duration-200 ease-in -m-px py-6 px-5 items-start border border-solid border-n-weak"
    :class="{
      'hover:enabled:border-n-blue-9 hover:enabled:shadow-md disabled:opacity-60 disabled:cursor-not-allowed':
        !isComingSoon,
      'cursor-not-allowed disabled:opacity-80': isComingSoon,
    }"
  >
    <div
      class="flex size-10 items-center justify-center rounded-full bg-n-alpha-2"
    >
      <Icon :icon="icon" class="size-6" :style="iconColor ? { color: iconColor } : {}" />
    </div>

    <div class="flex flex-col items-start gap-1.5">
      <h3 class="text-n-slate-12 text-sm text-start font-medium capitalize">
        {{ title }}
      </h3>
      <p class="text-n-slate-11 text-start text-sm">
        {{ description }}
      </p>
    </div>

    <div
      v-if="isComingSoon"
      class="absolute inset-0 flex items-center justify-center backdrop-blur-[2px] rounded-2xl bg-gradient-to-br from-n-background/90 via-n-background/70 to-n-background/95 cursor-not-allowed"
    >
      <span class="text-n-slate-12 font-medium text-sm">
        {{ $t('CHANNEL_SELECTOR.COMING_SOON') }} 🚀
      </span>
    </div>
  </button>
</template>
